import { render, staticRenderFns } from "./VppApplicationToken.vue?vue&type=template&id=b8672844&"
import script from "./VppApplicationToken.vue?vue&type=script&lang=js&"
export * from "./VppApplicationToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports